import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit';

import * as styles from './styles.css';

interface INewAnswerProps {
  userInfo: React.ReactElement<any> | null;
  answer: React.ReactElement<any>;
  anonymous: React.ReactElement<any> | null;
}

export const NewAnswer = ({
  userInfo,
  answer,
  anonymous,
}: React.PropsWithChildren<INewAnswerProps>): React.JSX.Element => {
  return (
    <div className={styles['content']}>
      {userInfo && (
        <div className={styles['section']}>
          <div className={styles['title']}>
            <UIHeading4>Расскажите о себе</UIHeading4>
          </div>
          {userInfo}
        </div>
      )}

      <div className={styles['section']}>
        <div className={styles['title']}>
          <UIHeading4>Ваш ответ</UIHeading4>
        </div>
        {answer}
      </div>
      {anonymous && <div className={styles['section']}>{anonymous}</div>}
    </div>
  );
};
